<template>
  <v-card class="dialog-card">
    <ModalHeader
      helpFileName="CreatePreset"
      icon="mdi-tune-variant"
      :modalTitle="
        forceTemplateName ? 'Create ' + forceTemplateName : 'Create Preset'
      "
      @close="emit('close')"
      :modalSubtitle="'Create preset to create scenes from'" />
    <div
      class="px-5"
      style="display: flex; flex-direction: column">
      <v-text-field
        v-on:keyup.enter="createPreset"
        filled
        autofocus
        style="height: 66px"
        :label="forceTemplateName ? forceTemplateName + ' Name' : 'Preset Name'"
        v-model="newPreset.name"></v-text-field>
      <v-autocomplete
        v-on:keyup.enter="createPreset"
        filled
        :disabled="forceTemplateUid"
        auto-select-first
        style="height: 66px"
        label="Template"
        :items="orderedTemplates"
        item-title="display_name"
        item-value="uid"
        v-model="newPreset.template_uid"
        @change="onTemplateChange"></v-autocomplete>
    </div>
    <div class="modal-footer">
      <v-btn
        :disabled="!newPreset.name || !newPreset.template_uid"
        @click="createPreset()"
        :loading="save_loading"
        color="primary"
        block
        variant="flat">
        Create
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import { ref, computed, watch } from 'vue';
import { $http } from '../../stores/http.js';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';

const props = defineProps([
  'forceTemplateUid',
  'forceTemplateName',
  'forceProperties',
]);
const emit = defineEmits(['close']);
const newPreset = ref({
  name: '',
  template_uid: '',
});
const save_loading = ref(false);

const localStorageKey = 'lastSelectedTemplateUid';

// Load last selected template UID from local storage
newPreset.value.template_uid = localStorage.getItem(localStorageKey) || '';
if (props.forceTemplateUid) {
  newPreset.value.template_uid = props.forceTemplateUid;
}
// Computed templates list from deluge store
const templates = computed(() =>
  Object.values(deluge.templates).filter((t) => !t?.extra_info?.preset)
);

// Computed ordered templates based on last selected UID
const orderedTemplates = computed(() => {
  const lastSelectedUid = newPreset.value.template_uid;
  if (lastSelectedUid) {
    const ordered = [
      ...templates.value.filter((t) => t.uid === lastSelectedUid),
      ...templates.value.filter((t) => t.uid !== lastSelectedUid),
    ];
    return ordered;
  }
  return templates.value;
});

// Watcher to update local storage and reorder templates on UID change
watch(
  () => newPreset.value.template_uid,
  (newVal) => {
    if (newVal) {
      localStorage.setItem(localStorageKey, newVal);
    }
  }
);

// Function to reorder templates when template UID changes
function onTemplateChange() {
  const lastSelectedUid = newPreset.value.template_uid;
  if (lastSelectedUid) {
    const selectedTemplate = templates.value.find(
      (t) => t.uid === lastSelectedUid
    );
    if (selectedTemplate) {
      const index = templates.value.indexOf(selectedTemplate);
      templates.value.splice(index, 1);
      templates.value.unshift(selectedTemplate);
    }
  }
}

async function createPreset() {
  save_loading.value = true;
  console.log(props.forceProperties);
  if (props.forceProperties) {
    for (const [key, value] of Object.entries(props.forceProperties)) {
      newPreset.value[key] = value;
    }
  }
  console.log(newPreset.value);
  try {
    await $http('POST', '/create_preset', JSON.stringify(newPreset.value));
    emit('close');
  } finally {
    save_loading.value = false;
  }
}

// Initialize the order on load
if (newPreset.value.template_uid) {
  onTemplateChange();
}
</script>
<style>
.available_chip {
  opacity: 0.45;
}
.available_chip:hover {
  opacity: 1;
}
</style>
